module.exports = __webpack_public_path__ + "media/images/operation_jobs/door_close_shoes-981a593b4b28da94160eb1920d058301.gif";